import { AverageRateRmReport } from '@gtpl/shared-models/production-management';
import { RMGrnService } from '@gtpl/shared-services/raw-material-procurement';
import { Button, Card, Col, DatePicker, Form, Row, Table } from 'antd'
import { useForm } from 'antd/lib/form/Form';
import moment, { Moment } from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import {  UndoOutlined,DownloadOutlined,SearchOutlined } from '@ant-design/icons';
import { Excel } from 'antd-table-saveas-excel';
// import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';


const RmAverageRateReport = () => {

    const {RangePicker}= DatePicker;
const [averageRateReport,setAverageRateReport]=useState([])
const [searchText, setSearchText] = useState('');
const [searchedColumn, setSearchedColumn] = useState('');
const searchInput = useRef(null);
const[form] = useForm()
const service= new RMGrnService()
const [page, setPage] = useState(1);
const [pageSize, setPageSize] = useState<number>(null);

useEffect(()=>{
    getAverageRateReport()
},[])




const getAverageRateReport = () => {
    const req =new AverageRateRmReport()
    if(form.getFieldValue('date')!= undefined){
        req.fromDate = moment(form.getFieldValue('date')[0]).format('YYYY-MM-DD')
        req.toDate = moment(form.getFieldValue('date')[1]).format('YYYY-MM-DD')
      }
    service.getAverageRateReport(req).then((res) => {
        if (res.status) {
            setAverageRateReport(res.data)
        }
        else{
            setAverageRateReport([])  
        }
    })
}


    const getDefaultFinancialYear = (): [Moment, Moment] => {
        const currentYear = moment().year();
        const startOfFinancialYear = moment(`04-01-${currentYear}`, 'MM-DD-YYYY');
        const endOfFinancialYear = startOfFinancialYear.clone().add(1, 'year').subtract(1, 'day');
        return [startOfFinancialYear, endOfFinancialYear];
      };

      const defaultFinancialYear = getDefaultFinancialYear();

      const currentYear = moment().year();
      const startOfFinancialYear = moment(`04-01-${currentYear}`, 'MM-DD-YYYY');
      let endOfFinancialYear = startOfFinancialYear.clone().add(1, 'year').subtract(1, 'day');
      if (moment().isAfter(endOfFinancialYear)) {
        endOfFinancialYear = endOfFinancialYear.clone().add(1, 'year');
      }
      const financialYear = `${startOfFinancialYear.format('YYYY')}-${endOfFinancialYear.format('YYYY')}`;

      const search =() =>{
        getAverageRateReport()
      }

      const resetHandler =() =>{
        form.resetFields()
        getAverageRateReport()
      }


const Columns:any=[
  {
    title: 'S.No',
    width:"20px",
    render: (text, object, index) => (page - 1) * pageSize + (index + 1)

  },
  {
    title: "Count",
    dataIndex: "count",
    // render: (text, record) => {
    //   const obj = record?.count;
    //   // If there's only one part, parse and remove trailing zeros
    //   const startCount = parseFloat(obj[0])?.toString();
    //   const endCount = obj[1] ? parseFloat(obj[1])?.toString() : null;
    //   // Display single number if both parts are the same or if there's only one part
    //   const count = endCount ? (startCount === endCount ? startCount : `${startCount}-${endCount}`) : startCount;
    //   return count;
    // },
    // sorter: (a, b) => {
    //   const aCount = a.count.split('-');
    //   const bCount = b.count.split('-');
  
    //   const aStart = parseFloat(aCount[0]);
    //   const aEnd = parseFloat(aCount[1] || aCount[0]);
    //   const bStart = parseFloat(bCount[0]);
    //   const bEnd = parseFloat(bCount[1] || bCount[0]);
  
    //   return aStart === bStart ? aEnd - bEnd : aStart - bStart;
    // },
    // sortDirections: ['descend', 'ascend'],   
  },
  

{
  title: "Quantity(In Kgs)",
  dataIndex: "totalQuantity",
  render: (text, record) => {
    const totalQuantity = parseFloat(Number(record.totalQuantity).toFixed(2));
    return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(totalQuantity);
  },
  sorter: (a, b) => a.totalQuantity - b.totalQuantity,
  sortDirections: ['descend', 'ascend'],
},
    {
      title: "Avg Rate(per kg)",
      render: (text, record) => {
          const totalQuantity = Number(record.totalQuantity);
          const totalAmount = Number(record.totalAmount);
          const rate = (totalAmount) / (totalQuantity);
          return (
              <>
                  {parseFloat(rate.toFixed(2))?.toString()}
              </>
          );
      },
      sorter: (a, b) => {
          const aRate = Number(a.totalAmount) / Number(a.totalQuantity);
          const bRate = Number(b.totalAmount) / Number(b.totalQuantity);
          return aRate - bRate;
      },
      sortDirections: ['descend', 'ascend'],
  },
  {
    title: "Amount",
    dataIndex: "totalAmount",
    render: (text, record) => {
      const totalAmount = parseFloat(Number(record.totalAmount).toFixed(2));
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(totalAmount);
    },
    sorter: (a, b) => Number(a.totalAmount) - Number(b.totalAmount),
    sortDirections: ['descend', 'ascend'],
  }
]

const exportExcel = () => {
  if (!averageRateReport || averageRateReport.length === 0) return;

  // Calculate totals
  let totalQty = 0;
  let totalAmt = 0;

  const excelData = averageRateReport.map((item, index) => {
    totalQty += parseFloat(item.totalQuantity) || 0;
    totalAmt += parseFloat(item.totalAmount) || 0;

    return {
      "S.No": index + 1,
      "Count": item.count,
      "Quantity (In Kgs)": parseFloat(Number(item.totalQuantity).toFixed(2)),
      "Avg Rate (per kg)": parseFloat((item.totalAmount / item.totalQuantity).toFixed(2)),
      "Amount": parseFloat(Number(item.totalAmount).toFixed(2)),
    };
  });

  excelData.push({
    "S.No": undefined,
    "Count": "Total",
    "Quantity (In Kgs)": parseFloat(totalQty.toFixed(2)),
    "Avg Rate (per kg)": undefined,
    "Amount": parseFloat(totalAmt.toFixed(2)),
  });

  const excel = new Excel();
  excel
    .addSheet("rm-average-rate-report.xlsx")
    .addColumns([
      { title: "S.No", dataIndex: "S.No", width: 50 },
      { title: "Count", dataIndex: "Count", width: 100 },
      { title: "Quantity (In Kgs)", dataIndex: "Quantity (In Kgs)", width: 200 },
      { title: "Avg Rate (per kg)", dataIndex: "Avg Rate (per kg)", width: 200 },
      { title: "Amount", dataIndex: "Amount", width: 200 },
    ])
    .addDataSource(excelData, { str2num: true });
  excel.saveAs("rm-average-rate-report.xlsx");
};




  return (
    <div>
        <Card title={<span style={{color:'white'}}>Average RM Rate Report ({financialYear})</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={
      
        <Button icon={<DownloadOutlined />} onClick={() => { exportExcel() }} style={{marginRight:30}}>
          Get Excel
        </Button>}>        
        
        <Form form={form}  onFinish={search} layout='vertical'>
           <Row>
           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }} lg={{ span: 8 }} xl={{ span: 6 }}>
          <Form.Item label='Date' name='date' >
            <RangePicker  />
          </Form.Item>
        </Col>
        <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>
          <Form.Item>
            <Button type='primary' htmlType='submit'>Search</Button>
          </Form.Item>
        </Col>
        <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>
          <Form.Item>
            <Button
              onClick={resetHandler}
              type="primary"
           
              style={{ float: 'right', marginRight: '20px' }}
              icon={<UndoOutlined />}
            >
              Reset
            </Button>
          </Form.Item>
        </Col>
           </Row>
        </Form>
        <Table columns={Columns} dataSource={averageRateReport} pagination={{
              pageSize: 100, 
              onChange(current, pageSize) {
                setPage(current);
              }

            }}
            summary={(pageData) => {
              let totalQty = 0;
              let totalAmt = 0;

            
              pageData.forEach(({ totalQuantity,totalAmount }) => {
                  totalQty += parseFloat(totalQuantity) || 0;
                  totalAmt += parseFloat(totalAmount) || 0;

                });
            
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={1} colSpan={2}>
                    Total
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2}>
                    {totalQty.toFixed(2)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4}>
                    {totalAmt.toFixed(2)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }} 
             />
        </Card>
    </div>
  )
}

export default RmAverageRateReport